import React from "react";
// import dynamic from "next/dynamic";

import * as Styles from "./styles";
import { ModalMobile as MobileModal } from "@acko-tech/building-blocks.ui.modal";
// const MobileModal = dynamic(
//   () =>
//     import("@acko-tech/building-blocks.ui.modal").then(mod => mod.ModalMobile),
//   {
//     ssr: true
//   }
// );
interface DetailsModalProps {
  show: boolean;
  isLoggedIn: boolean;
  isDesktop: boolean;
  lastDigits?: string;
  bikeNumber?: string;
  onClose: () => void;
}

function ExistingPolicyModal(props: DetailsModalProps) {
  const {
    show,
    onClose,
    isLoggedIn,
    isDesktop
    // lastDigits,
    // bikeNumber
  } = props;

  const hrefValue = isLoggedIn
    ? `${process.env.HOST_URL}`
    : `${process.env.HOST_URL}/login`;

  const renderContent = (isLoggedIn: boolean) => {
    return (
      <Styles.Wrapper isDesktop={isDesktop}>
        <Styles.PolicyIcon
          isDesktop={isDesktop}
          src={require("@public/images/existingPolicy.svg?url")}
        />
        <Styles.Heading>Welcome back!</Styles.Heading>
        <Styles.Info>
          Looks like you already have a policy insured with Acko
          {!isLoggedIn && `. Please login to access your policy`}
        </Styles.Info>
        <Styles.CTA onClick={onClose} href={hrefValue}>
          {!isLoggedIn ? `Login` : `Access your policy`}
        </Styles.CTA>
      </Styles.Wrapper>
    );
  };

  const modalProps: any = {
    closeOnOverlayClick: true,
    show: show,
    onHide: onClose,
    closePosition: "right",
    closeComponent: (
      <Styles.CloseIcon
        src={require("@public/images/close.svg?url")}
        onClick={onClose}
      />
    )
  };

  return (
    <>
      <MobileModal {...modalProps}>{renderContent(isLoggedIn)}</MobileModal>
    </>
  );
}

export default ExistingPolicyModal;
